module.exports = __webpack_public_path__ + "img/dark-email.f206a850.png";